import React from "react";
import Description from "./Description";
import Discount from "./DIscount";

const Highlight = () => {
  return (
    <div className="highlight_wrapper">
      <Description />
      <Discount />
    </div>
  );
};

export default Highlight;
